import { render, staticRenderFns } from "./Portais.vue?vue&type=template&id=1a457f82&scoped=true&"
import script from "./portais.js?vue&type=script&lang=js&"
export * from "./portais.js?vue&type=script&lang=js&"
import style0 from "./Portais.vue?vue&type=style&index=0&id=1a457f82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a457f82",
  null
  
)

export default component.exports